import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "pos-client-manager mt-20" };
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-15" };
const _hoisted_3 = { class: "mb-0 text-black fw-bold" };
const _hoisted_4 = { class: "text-muted fs-13 mb-20" };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-md-2" };
const _hoisted_8 = { class: "form-group mb-15" };
const _hoisted_9 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_10 = { class: "col-md-5" };
const _hoisted_11 = { class: "form-group mb-15" };
const _hoisted_12 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_13 = { class: "col-md-5" };
const _hoisted_14 = { class: "form-group mb-15" };
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_16 = { class: "col-md-6" };
const _hoisted_17 = { class: "form-group mb-15" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = { class: "col-md-6" };
const _hoisted_20 = { class: "form-group mb-15" };
const _hoisted_21 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_22 = { class: "d-flex align-items-center gap-2 mt-10" };
const _hoisted_23 = ["disabled"];
const _hoisted_24 = {
    key: 2,
    class: "pos-client-info p-15 border rounded bg-light"
};
const _hoisted_25 = { class: "row align-items-center" };
const _hoisted_26 = { class: "col-auto" };
const _hoisted_27 = {
    class: "avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center",
    style: { "width": "45px", "height": "45px" }
};
const _hoisted_28 = { class: "fw-bold" };
const _hoisted_29 = { class: "col" };
const _hoisted_30 = { class: "fw-bold text-black" };
const _hoisted_31 = { class: "text-muted fs-13" };
const _hoisted_32 = {
    key: 0,
    class: "me-3"
};
const _hoisted_33 = { key: 1 };
const _hoisted_34 = { class: "col-auto" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t('posClient.title')), 1),
            (_ctx.posClient && !_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.isEditing = true)),
                    type: "button",
                    class: "btn btn-sm btn-outline-primary rounded-1"
                }, [
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-edit" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.edit')), 1)
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('posClient.description')), 1),
        (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
            : (!_ctx.posClient || _ctx.isEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("form", {
                        onSubmit: _cache[8] || (_cache[8] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.savePosClient && _ctx.savePosClient(...args)), ["prevent"]))
                    }, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('posClient.civility')) + " *", 1),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formData.civilite) = $event)),
                                        class: "form-select shadow-none rounded-0",
                                        required: ""
                                    }, [...(_cache[11] || (_cache[11] = [
                                            _createElementVNode("option", { value: "Monsieur" }, "Monsieur", -1),
                                            _createElementVNode("option", { value: "Madame" }, "Madame", -1),
                                            _createElementVNode("option", { value: "Autre" }, "Autre", -1)
                                        ]))], 512), [
                                        [_vModelSelect, _ctx.formData.civilite]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('posClient.firstName')) + " *", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formData.first_name) = $event)),
                                        class: "form-control shadow-none rounded-0",
                                        placeholder: "Ex: Client",
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _ctx.formData.first_name]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('posClient.lastName')) + " *", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.formData.last_name) = $event)),
                                        class: "form-control shadow-none rounded-0",
                                        placeholder: "Ex: Morges",
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, _ctx.formData.last_name]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('posClient.email')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "email",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formData.email) = $event)),
                                        class: "form-control shadow-none rounded-0",
                                        placeholder: "pos_restaurant@example.com"
                                    }, null, 512), [
                                        [_vModelText, _ctx.formData.email]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('posClient.phone')), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formData.phone_number) = $event)),
                                        class: "form-control shadow-none rounded-0",
                                        placeholder: "+41 700 23 67 89"
                                    }, null, 512), [
                                        [_vModelText, _ctx.formData.phone_number]
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-success btn-sm px-4 rounded-1",
                                disabled: !_ctx.isFormValid
                            }, _toDisplayString(_ctx.$t('common.save')), 9, _hoisted_23),
                            (_ctx.posClient)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    onClick: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                                    class: "btn btn-outline-secondary btn-sm px-4 rounded-1"
                                }, _toDisplayString(_ctx.$t('common.cancel')), 1))
                                : _createCommentVNode("", true),
                            (_ctx.posClient && !_ctx.isEditing)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    onClick: _cache[7] || (_cache[7] =
                                        //@ts-ignore
                                        (...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                                    class: "btn btn-outline-danger btn-sm px-4 rounded-1 ms-auto"
                                }, _toDisplayString(_ctx.$t('common.delete')), 1))
                                : _createCommentVNode("", true)
                        ])
                    ], 32)
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.posClient.first_name?.charAt(0)) + _toDisplayString(_ctx.posClient.last_name?.charAt(0)), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.posClient.civilite) + " " + _toDisplayString(_ctx.posClient.first_name) + " " + _toDisplayString(_ctx.posClient.last_name), 1),
                            _createElementVNode("div", _hoisted_31, [
                                (_ctx.posClient.email)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-email me-1" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.posClient.email), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.posClient.phone_number)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-telephone me-1" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.posClient.phone_number), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[9] || (_cache[9] =
                                    //@ts-ignore
                                    (...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                                class: "btn btn-outline-danger btn-sm rounded-1",
                                title: "Supprimer"
                            }, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                ]))])
                        ])
                    ])
                ]))
    ]));
}
